module.exports = __webpack_public_path__ + "img/wallet-report-green.7656e39e.svg";